export default "__VITE_ASSET__DIZA$ElF__"